<template>
	<div class="push-notification" v-if="showPushNotice && fatherShow">
		<div class="text">{{ $t('message.pushNotifications') }}</div>
		<div class="push-btn" @click="openSetting">{{ $t('message.pushNotificationsOpen') }}</div>
		<div class="close-btn" @click="showPushNotice = false">
			<van-icon name="cross" color="#999999" size="10" />
		</div>
	</div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import { logAFEvent, SystemSettingType, getSystemSetting, checkJsApi, checkBridgeVersion, openSystemSetting } from '@voghion/native-api'

/**
 * 导航栏
 */
const props = withDefaults(
	defineProps<{
		fatherShow?: any
	}>(),
	{
		fatherShow: true,
	}
)

const showPushNotice = ref(false)

const appNoticePushInit = () => {
	if (checkBridgeVersion('1.1.0')) {
		checkJsApi({
			api: getSystemSetting
		}).then((res) => {
			if (res.result) {
				getSystemSetting().then((res) => {
					if (res.data?.notificationEnable) {
						showPushNotice.value = false
					} else {
						showPushNotice.value = true
						logAFEvent({
							event: 'showSPM',
							spm: '01010430300',
							spmName: 'messageNotice',
						})
					}
				})
			}
		})
	}
}

const openSetting = () => {
	logAFEvent({
		event: 'clickSPM',
		spm: '01010430301',
		spmName: 'messageNoticeOpen',
	})

	openSystemSetting({
		type: SystemSettingType.Notification
	}).then((res) => {
		console.log(res);
	})
}

onMounted(() => {
	appNoticePushInit()

	document.addEventListener('visibilitychange', function () {
		if (document.visibilityState === 'visible') {
			appNoticePushInit()
		}
	})
})

</script>

<style lang="scss" scoped>
.push-notification {
	display: flex;
	align-items: center;
	padding: 8px 14px;
	background: #FFF5DE;

	.text {
		flex: 1;
		font-size: 12px;
		color: #333333;
	}

	.push-btn {
		height: 24px;
		line-height: 24px;
		padding: 0 8px;
		margin-left: 10px;
		background-color: #FDBB2B;
		border-radius: 12px;
	}

	.close-btn {
		padding: 0 10px;
		margin-left: 16px;
	}
}
</style>
